@if (context.visitInTerminalPlanning()) {
  <div class="row">
    <div class="col-md-6">
      @if (context.visit.visitDeclaration.arrivalVoyage) {
        <div class="fieldset"
             [ngClass]="{'disabled' : context.getVisitStatus() !== 'EXPECTED'}">
          @if (context.terminalPlanningEnabled()) {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>Terminal planning?</label>
                <div class="tooltipContent">Select 'Yes' to coordinate the planning with the terminal before declaring
                  the visit to the port authority.<br/>
                  Select 'No' to start declaring to the port authority
                </div>
              </app-info>
              <app-yes-no [disabled]="context.visit.terminalPlanningEnabled || context.visitHasTerminalPlannings()"
                          [(ngModel)]="context.visit.terminalPlanningEnabled" required="true"></app-yes-no>
            </app-form-group>
          }
          <app-form-group>
            <label for="arrivalVoyage-number">Voyage number</label>
            <input [(ngModel)]="context.visit.visitDeclaration.arrivalVoyage.voyageNumber" id="arrivalVoyage-number"
                   type="text" maxlength="17" class="form-control" [required]="inboundVoyageNumberRequired()">
          </app-form-group>
          <app-form-group>
            <label for="arrivalVoyage-carrierName">Carrier</label>
            <app-search
              [disabled]="!context.visit.visitDeclaration.arrivalVoyage.carrier?.name && !!context.visit.visitDeclaration.arrivalVoyage.carrier?.smdgCode"
              [(ngModel)]="context.visit.visitDeclaration.arrivalVoyage.carrier"
              dataKey="name" [searchFunction]="searchCarrier" id="arrivalVoyage-carrierName" required
              [inputFormatter]="carrierFormatter">
            </app-search>
          </app-form-group>
        </div>
      }
    </div>
    <div class="col-md-6">
      <app-form-group>
        <label for="vesselName">Vessel</label>
        <app-search [(ngModel)]="context.visit.vessel" [searchFunction]="searchVessel"
                    [inputFormatter]="vesselFormatter"
                    [minCharacters]="3" placeholder="Name or IMO number" dataKey="imoCode" id="vesselName" required>
        </app-search>
      </app-form-group>
      <app-form-group>
        <label for="arrivalVoyage-carriersmdgcode">Carrier smdg code</label>
        <input
          [ngModel]="context.visit.visitDeclaration.arrivalVoyage.carrier && context.visit.visitDeclaration.arrivalVoyage.carrier.smdgCode"
          (ngModelChange)="context.visit.visitDeclaration.arrivalVoyage.carrier = $event ? {smdgCode : $event} : null"
          required
          id="arrivalVoyage-carriersmdgcode" type="search" class="form-control" maxlength="17"
          [disabled]="context.visit.visitDeclaration.arrivalVoyage.carrier?.name && !!context.visit.visitDeclaration.arrivalVoyage.carrier?.smdgCode">
      </app-form-group>
    </div>
  </div>
} @else {
  <div class="row">
    <!--Dangerous goods-->
    @if (context.visit.portOfCall.paDeclarationRequired) {
      <div class="declaration-block col-md">
        @if (!userIsNextOwnerOrDeclarant()) {
          <div>
            @if (context.terminalPlanningEnabled()) {
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>Terminal planning?</label>
                  <div class="tooltipContent">Select 'Yes' to coordinate the planning with the terminal before declaring
                    the visit to the Port Authority.<br/>
                    Select 'No' to start declaring to the Port Authority
                  </div>
                </app-info>
                <app-yes-no [disabled]="context.visit.terminalPlanningEnabled || context.visitHasTerminalPlannings()"
                            [(ngModel)]="context.visit.terminalPlanningEnabled" required="true"></app-yes-no>
              </app-form-group>
            }
            <app-form-group>
              <label for="dangerousGoodsLoading">Loading DG</label>
              <app-yes-no [(ngModel)]="context.visit.visitDeclaration.portVisit.dangerousGoodsLoading" required
                          id="dangerousGoodsLoading"></app-yes-no>
              <div class="invalid-feedback">Are dangerous goods being loaded?</div>
            </app-form-group>
            <app-form-group>
              <label for="dangerousGoodsDischarge">Discharge DG</label>
              <app-yes-no [(ngModel)]="context.visit.visitDeclaration.portVisit.dangerousGoodsDischarge" required
                          id="dangerousGoodsDischarge"></app-yes-no>
              <div class="invalid-feedback">Are dangerous goods being discharged?</div>
            </app-form-group>
            <app-form-group>
              <label for="dangerousGoodsTransit">Transit DG</label>
              <app-yes-no [(ngModel)]="context.visit.visitDeclaration.portVisit.dangerousGoodsTransit" required
                          id="dangerousGoodsTransit"></app-yes-no>
              <div class="invalid-feedback">Are dangerous goods being transited?</div>
            </app-form-group>
          </div>
        }
        @if (userIsNextOwnerOrDeclarant()) {
          <div class="always-enabled">
            <app-form-group>
              <label for="dangerousGoodsLoading">Loading DG</label>
              <app-yes-no [(ngModel)]="context.visit.nextVisitDeclaration.dangerousGoodsLoading"></app-yes-no>
              <div class="invalid-feedback">Are dangerous goods being loaded?</div>
            </app-form-group>
            <app-form-group>
              <label for="dangerousGoodsDischarge">Discharge DG</label>
              <app-yes-no [(ngModel)]="context.visit.nextVisitDeclaration.dangerousGoodsDischarge"></app-yes-no>
              <div class="invalid-feedback">Are dangerous goods being discharged?</div>
            </app-form-group>
            <app-form-group>
              <label for="dangerousGoodsTransit">Transit DG</label>
              <app-yes-no [(ngModel)]="context.visit.nextVisitDeclaration.dangerousGoodsTransit"></app-yes-no>
              <div class="invalid-feedback">Are dangerous goods being transited?</div>
            </app-form-group>
          </div>
        }
        <app-form-group>
          <label for="vesselInspectionRequired">Requires inspection</label>
          <app-yes-no [(ngModel)]="context.visit.visitDeclaration.portVisit.vesselInspectionRequired" (ngModelChange)="context.visit.visitDeclaration.portVisit.shipConfiguration = $event
                  ? context.visit.visitDeclaration.portVisit.shipConfiguration : null" required
                      id="vesselInspectionRequired"></app-yes-no>
          <div class="invalid-feedback">Does the vessel require inspection?</div>
        </app-form-group>
        @if (isRotterdam || isAmsterdam) {
          <app-form-group>
            <label for="fumigatedCargoInBulk">Fumigated cargo in bulk</label>
            <app-yes-no [(ngModel)]="context.visit.visitDeclaration.portVisit.fumigatedCargoInBulk"
                        id="fumigatedCargoInBulk"></app-yes-no>
            <div class="invalid-feedback">Is cargo in bulk fumigated ?</div>
          </app-form-group>
        }
        @if (context.visit.visitDeclaration.portVisit.vesselInspectionRequired) {
          <app-form-group>
            <label for="shipConfiguration">Ship Configuration</label>
            <app-select [(ngModel)]="context.visit.visitDeclaration.portVisit.shipConfiguration" required
                        [options]="shipConfigurations" [formatter]="shipConfigurationFormatter" id="shipConfiguration">
            </app-select>
          </app-form-group>
        }
      </div>
    }
    <!--Other-->
    <div class="declaration-block col-md">
      <app-form-group>
        <label for="clientReferenceNumber">Client reference</label>
        <input [(ngModel)]="context.visit.visitDeclaration.clientReferenceNumber" id="clientReferenceNumber" type="text"
               maxlength="35" class="form-control">
      </app-form-group>
      @if(isRotterdam) {
        <app-form-group>
          <label for="vesselEmailAddress">Vessel email address</label>
          <vessel-communication-component [visit]="context.visit" label="Vessel email address" [type]="emailType">
          </vessel-communication-component>
        </app-form-group>
        <app-form-group>
          <app-info class="formGroupLabel">
            <label for="vessel">Vessel phone number</label>
            <span class="tooltipContent">Use only numbers, spaces, +, or - (no parentheses).</span>
          </app-info>
          <vessel-communication-component [visit]="context.visit" label="Vessel phone number" [type]="phoneType">
          </vessel-communication-component>
        </app-form-group>
      }
      @if (context.visit.portOfCall.paDeclarationRequired) {
        <app-form-group>
          <label>Defects</label>
          <app-multiselect [(ngModel)]="context.visit.visitDeclaration.portVisit.defectTypes" [options]="defectTypes"
                           [formatter]="defectsFormatter" title="Select any number of defects"
                           (ngModelChange)="context.visit.visitDeclaration.portVisit.defectTypes.length == 0 ? context.visit.visitDeclaration.portVisit.defectTypeRemarks = null : null"
                           placement="top-start" id="defectTypes" [horizontal]="true"></app-multiselect>
        </app-form-group>
      }
      @if (context.visit.visitDeclaration.portVisit.defectTypes
      && context.visit.visitDeclaration.portVisit.defectTypes.length > 0) {
        <app-form-group>
          <label>Defect remarks</label>
          <textarea [(ngModel)]="context.visit.visitDeclaration.portVisit.defectTypeRemarks" maxlength="255"
                    class="form-control" rows="1"></textarea>
        </app-form-group>
      }
    </div>
  </div>
}

